import * as THREE from 'three';
import { ClosePath } from '../objects';
import { mobb } from '../math/mobb';

class rightAngle {
    // 誤差として0.01度の角度
    private epsilon = THREE.MathUtils.degToRad(0.01);

    public check(shape: ClosePath) : number[] {
      const points = new mobb().computeCorners(shape.position);

      if (!points.length) return [];

      //
      const parallel = (v1: THREE.Vector2, v2: THREE.Vector2) : boolean => {
        const radian = Math.acos(v1.dot(v2));
        // 誤差を考慮した 0度 or 180度 判定
        if ((radian < this.epsilon)) return true;
        return ((Math.PI - radian) < this.epsilon);
      };

      const p1 = points[0];
      const p2 = points[1];
      const p3 = points[3];
      const v1 = p2.clone().sub(p1).normalize(); // 基準ベクトル1
      const v2 = p3.clone().sub(p1).negate().normalize(); // 基準ベクトル2

      const result: boolean[] = [];

      for (let i = 0; i < shape.position.length; i += 1) {
        const a = shape.position[i];
        const b = shape.position[(i + 1) % shape.position.length];
        const vec = b.clone().sub(a).normalize();

        // 基準となるベクトルvecと並行の場合trueが返る
        // 2つのベクトルv1,v2がvecと並行でない場合falseっとなるので、反転してtrueとする
        // いずれかが並行ならtrueをfalse
        result.push(!(parallel(v1, vec) || parallel(v2, vec)));
      }
      return [...Array(shape.position.length).keys()].filter((v: number, index: number) => result[index]);
    }
}

export default { rightAngle };
